import { Link } from 'react-router-dom';
import { AGENT_SETUP_BASE } from '../../constants/setupRoadmapSteps';
import styles from '../../styles/agents.module.css';

function AgentCard({ agent, onEdit, onDelete, onTest }) {
    const toolCount = agent.tools?.length || (agent.rag_collections?.length > 0 ? 1 : 0);
    const collectionCount = agent.rag_collections?.length || 0;
    
    // Extract collections from tools if using new format
    const collectionsFromTools = agent.tools
        ?.filter(t => t.type === 'rag')
        .flatMap(t => t.config?.collections || []) || [];
    const totalCollections = new Set([
        ...(agent.rag_collections || []),
        ...collectionsFromTools
    ]).size;

    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{agent.name}</h3>
                <span className={`${styles.cardBadge} ${agent.isActive ? styles.badgeActive : styles.badgeInactive}`}>
                    {agent.isActive ? 'Active' : 'Inactive'}
                </span>
            </div>
            
            {agent.description && (
                <p className={styles.cardDescription}>{agent.description}</p>
            )}
            
            <div className={styles.cardMeta}>
                <div className={styles.metaItem}>
                    <span>🔧</span>
                    <span>{toolCount} {toolCount === 1 ? 'tool' : 'tools'}</span>
                </div>
                {totalCollections > 0 && (
                    <div className={styles.metaItem}>
                        <span>📚</span>
                        <span>{totalCollections} {totalCollections === 1 ? 'collection' : 'collections'}</span>
                    </div>
                )}
                <div className={styles.metaItem}>
                    <span>🤖</span>
                    <span>{agent.defaultModel || 'llama3.2'}</span>
                </div>
            </div>
            
            <div className={styles.cardActions}>
                <Link
                    to={`${AGENT_SETUP_BASE}/manage/${agent.agentId}`}
                    className={styles.cardButton}
                >
                    Edit
                </Link>
                <Link
                    to={`/llm?agent=${agent.agentId}`}
                    className={styles.cardButton}
                >
                    Test
                </Link>
                <button
                    onClick={() => onDelete && onDelete(agent.agentId)}
                    className={`${styles.cardButton} ${styles.cardButtonDanger}`}
                >
                    Delete
                </button>
            </div>
        </div>
    );
}

export default AgentCard;
